import { AppCardSkeleton, AppCardSkeletonMetaFooter } from '@app/components/base/app-card';

/**
 * One skeleton placeholder card matching FragmentCard layout for video fragments.
 */
export function VideoFragmentCardSkeleton() {
  return <AppCardSkeleton footer={<AppCardSkeletonMetaFooter />} />;
}
